export default __webpack_public_path__ + "static/media/home_6.f455d2ad.svg";